import { api } from "../../utils/api";

export async function postSoldLand(data) {
  const id = data.land_id
  try {
    const response = await api.post(`soldLand`, data);
    return response.data;
  }  catch (error) {
    // Exibe o erro no console para facilitar a depuração
    console.error("Erro na requisição postSoldLand:", error);

    // Verifica se há uma resposta da API e extrai a mensagem de erro, caso contrário, retorna uma mensagem genérica
    const errorMessage = error.response?.data?.error || "Erro inesperado.";

    console.log(errorMessage)

    // Lança o erro com a mensagem apropriada
    throw new Error(errorMessage);
  }
}